import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { DiscountedPrice } from "@babackapp/return-widget-components/components/discounted-price";
import { getLineItemDisplay } from "@babackapp/return-widget-components/utils/line-item-display";
import { getExchangeVariantLabel } from "@babackapp/return-widget-components/utils/exchange-variant-label";
import type {
  DraftLineItem,
  Order,
  OrderLineItem,
} from "@babackapp/return-widget-components/types";

type Props = {
  item: DraftLineItem;
  orderLineItems: OrderLineItem[];
  order: Order | null;
  currency: string;
};

export function CompleteReturnLineItem({
  item,
  orderLineItems,
  order,
  currency,
}: Props) {
  const { title, subtitle, image, price, paidPrice } = getLineItemDisplay(
    orderLineItems,
    item.lineItemId,
  );

  const exchangeLabel =
    item.resolution === "exchange" && item.exchangeVariantId
      ? getExchangeVariantLabel(order, item.lineItemId, item.exchangeVariantId)
      : null;
  const variantDisplay =
    exchangeLabel && subtitle
      ? `${subtitle} → ${exchangeLabel}`
      : (exchangeLabel ?? subtitle);

  return (
    <Article>
      <ArticleImage
        src={image ?? undefined}
        layoutId={`img-complete-${item.lineItemId}`}
      />
      <ArticleTitle>{title}</ArticleTitle>
      <ArticleSubtitle>
        {variantDisplay && `${variantDisplay} · `}×{item.quantity}
        {!!price && (
          <>
            {" · "}
            <DiscountedPrice
              catalogCents={price}
              paidCents={paidPrice}
              quantity={item.quantity}
              currency={currency}
            />
          </>
        )}
      </ArticleSubtitle>
    </Article>
  );
}
